import React, { useEffect } from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import {getStateByPath} from "../../../redux/selectors";

// components
import TranslateButton from "../../../components/buttons/TranslateButton";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

// labels
import { LIST,  NO_DATA_FOUND} from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";

// services
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import AybCategoryFilters from "./_filters";
import {aybCategoryService} from "../../../jwt/_services/ayb/aybCategoryService";
import AybCategoryForm from "./_form";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

const AybCategoryList = props => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, category, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    useEffect( () => {
        console.log(category)
        if(filter || !app?.id )
            return

        props.setFilter(path, {
            fbDataBase : { id: app?.fbDataBase?.id},
            onlyRegistered : true,
            item :  {
                category : category,
                status : null
            }
        })
    }, [ app ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, aybCategoryService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(AybCategoryForm, { path, data, closeOnEscape:false, closeOnClickOutside: false})
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(AybCategoryForm, { path })
    }
    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: aybCategoryService,
        remove : genericIndexedActions.delete,
    } );

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        headerStyle: {width: '200px'},
    }, {
        dataField: 'titleEsEn',
        text: 'Titulo'
    }, {
        dataField: 'status',
        text: "Activo",
        headerStyle: {width: '80px'},
        headerAlign: 'center',
        align: 'center',
        formatter: (cell) => <ActiveFormatter active={cell}/>
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '200px'},
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <>
            <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
            <TranslateButton item={row} service={aybCategoryService} path={path}/>
            <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
        </>
    }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <AybCategoryFilters path={path} />

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = _ => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(AybCategoryList)